module.exports = __webpack_public_path__ + "static/media/number-guess.84cd0a5c.png";